import V2LogosFinanceNav from '~/components/v2/logos/FinanceNav.vue'
import V2LogosInsuranceNav from '~/components/v2/logos/InsuranceNav.vue'
import V2LogosResourcesNav from '~/components/v2/logos/ResourcesNav.vue'
import V2LogosUtilitiesNav from '~/components/v2/logos/UtilitiesNav.vue'

export const NAV_MENU_OBJ = [
  {
    title: 'Insurance',
    slug: 'insurance',
    iconComponent: V2LogosInsuranceNav,
    menu: [
      {
        title: 'Health Insurance',
        url: '/health-insurance/'
      },
      {
        title: 'Overseas Visitor Health Cover',
        url: '/health-insurance/visitors-visa-ovhc/'
      },
      {
        title: 'Life Insurance',
        url: '/life-insurance/'
      },
      {
        title: 'Car Insurance',
        url: '/car-insurance/'
      },
      {
        title: 'Travel Insurance',
        url: '/travel-insurance/'
      }
    ]
  },
  {
    title: 'Finance',
    slug: 'finance',
    iconComponent: V2LogosFinanceNav,
    menu: [
      {
        title: 'Home Loans',
        url: '/home-loans/'
      },
      {
        title: 'Car Loans',
        url: '/car-loans/'
      },
      {
        title: 'Credit Cards',
        url: '/credit-cards/'
      },
      {
        title: 'Personal Loans',
        url: '/personal-loans/'
      },
      {
        title: 'Reverse Mortgage',
        url: 'https://lp.compareclub.com.au/home-loan/reverse-mortgage/?utm_source=direct&v2=direct&utm_medium=organic&v1=organic&website_source=CompareClub&landing_page=https://compareclub.com.au/&ref=https://compareclub.com.au/'
      }
    ]
  },
  {
    title: 'Utilities',
    slug: 'utilities',
    iconComponent: V2LogosUtilitiesNav,
    menu: [
      {
        title: 'Energy',
        url: '/energy/'
      }
    ]
  },
  {
    title: 'Resources',
    slug: 'resources',
    iconComponent: V2LogosResourcesNav,
    menu: [
      {
        title: 'Articles',
        url: '/expert-analysis/'
      },
      {
        title: 'Smart explainers',
        url: '/health-insurance/guides/'
      },
      {
        title: 'Tools and calculators',
        url: '/home-loans/calculators/'
      },
      {
        title: 'Media hub',
        url: '/media/'
      },
      {
        title: 'Club+',
        url: '/dashboard/clubplus/'
      },
      {
        title: 'Compare Club App',
        url: '/dashboard/app/'
      }
    ]
  }
]
